import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';

function EbzModal(props) {
  const { isOpen, toggleModal, title, children, width, destroyOnClose, closable, topOffset } =
    props;

  return (
    <Modal
      width={width}
      title={title}
      open={isOpen}
      onCancel={toggleModal}
      destroyOnClose={destroyOnClose}
      footer={false}
      closable={closable}
      style={{ top: topOffset }}
    >
      {children}
    </Modal>
  );
}

EbzModal.defaultProps = {
  width: 700,
  destroyOnClose: true,
  closable: true,
  title: 'Ebz Modal',
  topOffset: 80
};

EbzModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.instanceOf(Object).isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  destroyOnClose: PropTypes.bool,
  topOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  closable: PropTypes.bool
};

export default EbzModal;
